import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JSEncrypt } from 'jsencrypt';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  private publicKey = '';
  private encryptor: JSEncrypt = new JSEncrypt();

  constructor(private http: HttpClient) {
    this.loadPublicKey();
  }

  private loadPublicKey(): void {
    this.http.get('assets/public_key.txt', { responseType: 'text' }).subscribe({
      next: (key: string) => {
        this.publicKey = key;
        this.encryptor.setPublicKey(this.publicKey);
      },
      error: (err) => {
      }
    });
  }

  public encrypt(value: string): string | false {
    if (!this.publicKey) {
      return false;
    }
    return this.encryptor.encrypt(value);
  }
}
